module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightbulb-off-fill-85dd9fe4.svg";